import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import "../../assets/scss/custom/components/upload-rename.scss";
import io from 'socket.io-client';
import toastr, { success } from 'toastr'
import * as faceapi from 'face-api.js';
import validateFaceImage from '../../utils/validateFace';


//Configuraciones
//const socket = io('https://tiendabastet.duckdns.org:8084');
//const baseUrl = 'https://tiendabastet.duckdns.org:8084';

//Desarrollo
const socket = io('https://tiendabastet.duckdns.org:8084');
const baseUrl = 'https://tiendabastet.duckdns.org:8084';


const UploadImage = () => {
  const videoRef = useRef(null);
  const location = useLocation();
  const [previewUrl, setPreviewUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const [mediaStream, setMediaStream] = useState(null);
  const mediaStreamRef = useRef(null); 
  const [isLoading, setIsLoading] = useState(false);
  const [user, setUser] = useState('no definido');
  const detectIntervalRef = useRef(null);
  const query = useQuery();
  const uniqueCode = query.get('code');
  const perfectCounterRef = useRef(0);
  const photoTakenRef = useRef(false);
  const [modelsLoaded, setModelsLoaded] = useState(false);

   // 

  // Captura el código único desde la URL
  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const code = params.get('code') || '';
  //   setUniqueCode(code);
  // }, [location]);

  useEffect(() => {
    const loadModels = async () => {
      try {
        await faceapi.nets.tinyFaceDetector.loadFromUri('/models');
        setModelsLoaded(true);
      } catch (err) {
        console.error("Error cargando modelos:", err);
      }
    };
    loadModels();
  }, []);

  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const onFileSelected = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = (e) => setPreviewUrl(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  
  const detectFaceLoop = async () => {
    if (detectIntervalRef.current) return;

    detectIntervalRef.current = setInterval(async () => {
      if (!videoRef.current) return;

      const displayWidth = 220;
      const displayHeight = 270;

      const videoWidth = videoRef.current.videoWidth;
      const videoHeight = videoRef.current.videoHeight;
      if (!videoWidth || !videoHeight) return;

      const detections = await faceapi.detectAllFaces(
        videoRef.current,
        new faceapi.TinyFaceDetectorOptions()
      );

      if (detections.length > 0) {
        const { box, score } = detections[0];

        const scaleX = displayWidth / videoWidth;
        const scaleY = displayHeight / videoHeight;

        const boxScaled = {
          x: box.x * scaleX,
          y: box.y * scaleY,
          width: box.width * scaleX,
          height: box.height * scaleY,
        };

        const area = boxScaled.width * boxScaled.height;
        const relativeSize = area / (displayWidth * displayHeight);

        const centerX = boxScaled.x + boxScaled.width / 2;
        const centerY = boxScaled.y + boxScaled.height / 2;

        const marcoCentroX = displayWidth / 2;
        const marcoCentroY = displayHeight / 2;

        const offsetX = centerX - marcoCentroX;
        const offsetY = centerY - marcoCentroY;

        //const debugEl = document.getElementById('debugInfo');
        //if (debugEl) {
        //  debugEl.innerText = `
        //    size: ${relativeSize.toFixed(2)}
        //    area: ${Math.round(area)}
        //    offsetX: ${Math.round(offsetX)}
        //    offsetY: ${Math.round(offsetY)}
        //  `;
        //}

        const idealSize = 0.29;
        const idealArea = 17426;
        const idealOffsetX = 1;
        const idealOffsetY = 23;

        const sizeOk = Math.abs(relativeSize - idealSize) <= 0.02;
        const areaOk = Math.abs(area - idealArea) <= 1500;
        const offsetXOk = Math.abs(offsetX - idealOffsetX) <= 15;
        const offsetYOk = Math.abs(offsetY - idealOffsetY) <= 15;
        const scoreOk = score >= 0.6;
        
        const dentroDelMarco = (
          boxScaled.x >= 0 &&
          boxScaled.y >= 0 &&
          boxScaled.x + boxScaled.width <= displayWidth &&
          boxScaled.y + boxScaled.height <= displayHeight
        );

        if (!dentroDelMarco) {
          showMessage('🧭 Alinea tu rostro con la silueta');
          perfectCounterRef.current = 0;
        } else if (!scoreOk) {
          showMessage('📷 Imagen borrosa o con poca luz');
          perfectCounterRef.current = 0;
        } else if (!sizeOk) {
          showMessage(relativeSize < idealSize ? '📏 Acércate un poco más' : '📏 Aléjate un poco');
          perfectCounterRef.current = 0;
        } else if (!offsetXOk) {
          showMessage(offsetX > idealOffsetX ? '👈 Muévete un poco a la izquierda' : '👉 Muévete un poco a la derecha');
          perfectCounterRef.current = 0;
        } else if (!offsetYOk) {
          showMessage(offsetY > idealOffsetY ? '⬆️ Baja un poco' : '⬇️ Sube un poco');
          perfectCounterRef.current = 0;
        } else if (!areaOk) {
          showMessage('📐 Ajusta un poco tu distancia');
          perfectCounterRef.current = 0;
        } else {
          showMessage('✅ ¡Perfecto! Capturando Automáticamente');
          perfectCounterRef.current += 1;

          if (perfectCounterRef.current >= 2 && !photoTakenRef.current) {
            console.log("✅ Condición perfecta alcanzada, tomando foto automáticamente...");
            photoTakenRef.current = true;
            setTimeout(() => {
              capturePhoto();
            }, 300);
          }
        }

      } else {
        showMessage('❌ No se detectó rostro');
      }
    }, 500);
  };



  const showMessage = (msg) => {
    const el = document.getElementById('face-message');
    if (el) el.innerText = msg;
  };



  const openCamera = async () => {
    setIsCameraOpen(true);

    if (!modelsLoaded) {
      alert("Por favor espera que el sistema termine de cargar...");
      return;
    }

    try {
      // Solicitar acceso a la cámara
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      mediaStreamRef.current = stream;
      setMediaStream(stream);

      if (videoRef.current) {
        videoRef.current.srcObject = stream;

        // Esperar que el video comience
        videoRef.current.onloadedmetadata = async () => {
          await detectFaceLoop();
        };


      }
    } catch (err) {
      console.error('Error al acceder a la cámara:', err);
    }
  };


  const stopCamera = () => {
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach(track => track.stop());
      mediaStreamRef.current = null;
      setMediaStream(null); 
    }

    if (detectIntervalRef.current) {
      clearInterval(detectIntervalRef.current);
      detectIntervalRef.current = null;
    }

    setIsCameraOpen(false);
  };


  const capturePhoto = () => {
    console.log("📸 Entró a capturePhoto()"); 
    if (!videoRef.current || !mediaStreamRef.current) {
      console.log("❌ No hay media stream activo");
      photoTakenRef.current = false; // <- permitir intentarlo de nuevo
      return;
    }

    const canvas = document.createElement('canvas');
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    const ctx = canvas.getContext('2d');

    // Verificar dimensiones del video
    console.log("🎥 Video dimensions:", videoRef.current.videoWidth, videoRef.current.videoHeight);

    if (videoRef.current.videoWidth === 0 || videoRef.current.videoHeight === 0) {
      console.log("⚠️ Video aún no está listo para capturar");
      return;
    }

    if (ctx) {
      ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
      canvas.toBlob((blob) => {
        console.log("🟡 Foto procesada en blob");
        if (blob) {
          const file = new File([blob], "captured-image.jpg", { type: "image/jpeg" });
          console.log("✅ Preview URL generado:", file); // 
          setSelectedFile(file);
          setPreviewUrl(URL.createObjectURL(blob));
          setIsCameraOpen(false);
          stopCamera();

          //detener bucle de deteccion de rostro
          clearInterval(detectIntervalRef.current);
          detectIntervalRef.current = null;
        } else {
          console.log("❌ No se pudo generar el blob");
        }
      }, "image/jpeg");
    }
  };

  const uploadImage = async () => {
    if (!selectedFile) {
      alert('Debe seleccionar una imagen');
      return;
    }
  
    try {
      setIsLoading(true);
  
      const formData = new FormData();
      formData.append('file', selectedFile);
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code') || '';
      formData.append('code', code);
      formData.append('email', user);
  
      const validationResult = await validateFaceImage(selectedFile);
      if (validationResult !== 'ok') {
        let msg = {
          'no-face': 'La imagen no contiene un rostro.',
          'too-small': 'El rostro detectado es demasiado pequeño.',
          'too-dark': 'La imagen está muy oscura.',
          'blurry': 'La imagen está borrosa.'
        }[validationResult] || 'Imagen inválida.';
      
        alert(`❌ ${msg} ❌`);
        setIsLoading(false);
        return;
      }


      const response = await fetch(`${baseUrl}/upload-with-email`, {
        method: 'POST',
        body: formData,
      });
  
      if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
  
      const data = await response.json();
      console.log('Imagen subida con éxito:', data);
  
      if (data.image_url) {
        // Guardar en localStorage
        localStorage.setItem('lastImageUpload', JSON.stringify({
          code: code, // ✅ usa el que sí está definido
          url: data.image_url,
          time: Date.now()
        }));
  
        // Enviar mensaje al iframe padre (chatbot)
        window.parent.postMessage(
          { type: 'imageUploaded', imageUrl: data.image_url },
          '*'
        );
        toastr.success("Imagen subida con éxito.");
        alert('✅ Imagen subida con éxito.\nPor favor, regrese al equipo donde escaneó el código QR para continuar.');
        
      } else {
        alert('❌ La respuesta del servidor no contiene URL.');
      }
  
    } catch (error) {
      console.error('Error al subir la imagen:', error);
      alert('❌ Error al subir imagen.');
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="wrapper">
      <div className="container">
        <h2>Por favor, sube una imagen</h2>

        {previewUrl && (
          <div className="image-preview">
            <img src={previewUrl} alt="Vista previa" />
          </div>
        )}

        <div className="button-container">
          {/*<label htmlFor="fileInput" className="file-label">
            <img src="/images/add_image.png" alt="Seleccionar imagen" className="icon" /> Galería
          </label>
          <input
            id="fileInput"
            type="file"
            onChange={onFileSelected}
            className="file-input"
            accept="image/*"
            hidden
          />*/}

          <button className="btn-icon" onClick={openCamera}>
            <img src="/images/camera.png" alt="Cámara" /> Cámara
          </button>
        </div>

        {isCameraOpen && (
          <div className="camera-container">
            {/*<video ref={videoRef} autoPlay />*/}

            <div style={{ position: 'relative', width: '220px', height: '270px', margin: 'auto' }}>
              {/*<div id="debugInfo" style={{
                position: 'absolute',
                top: 10,
                left: 10,
                color: 'white',
                fontSize: '12px',
                backgroundColor: 'rgba(0,0,0,0.5)',
                padding: '5px',
                borderRadius: '5px',
                zIndex: 100
              }}></div>

              <video
                ref={videoRef}
                autoPlay
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />*/}
              <video
                ref={videoRef}
                autoPlay
                muted
                playsInline
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            
              <img
                src="/images/silueta.png"
                alt="Guía de rostro"
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  width: '220px',
                  height: '270px',
                  transform: 'translate(-50%, -50%)',
                  opacity: 0.6,
                  pointerEvents: 'none',
                  zIndex: 5,
                }}
              />

              <p
                id="face-message"
                style={{
                  position: 'absolute',
                  bottom: '15px', 
                  left: '50%',
                  transform: 'translateX(-50%)',
                  color: 'white',
                  fontWeight: 'bold',
                  textShadow: '1px 1px black',
                  width: '90%',
                  textAlign: 'center',
                  zIndex: 20,
                  fontSize: '15px',
                }}
              ></p>
            </div>

            {/*<button className="btn-icon" onClick={capturePhoto}>
              <img src="/images/camera.png" alt="Capturar" /> Capturar Foto
            </button>*/}
          </div>
        )}

        <button
          onClick={uploadImage}
          className="btn-upload"
          disabled={isLoading || !previewUrl}
        >
          <img src="/images/up.png" alt="Subir" />
          {isLoading ? 'Subiendo...' : 'Subir Imagen'}
        </button>
      </div>
    </div>
  );
};

export default UploadImage;
